export const ZODIAC_SIGNS = [
  { key: "aries", glyph: "\u2648", name: "Aries", element: "fire" },
  { key: "taurus", glyph: "\u2649", name: "Taurus", element: "earth" },
  { key: "gemini", glyph: "\u264A", name: "Gemini", element: "air" },
  { key: "cancer", glyph: "\u264B", name: "Cancer", element: "water" },
  { key: "leo", glyph: "\u264C", name: "Leo", element: "fire" },
  { key: "virgo", glyph: "\u264D", name: "Virgo", element: "earth" },
  { key: "libra", glyph: "\u264E", name: "Libra", element: "air" },
  { key: "scorpio", glyph: "\u264F", name: "Scorpio", element: "water" },
  { key: "sagittarius", glyph: "\u2650", name: "Sagittarius", element: "fire" },
  { key: "capricorn", glyph: "\u2651", name: "Capricorn", element: "earth" },
  { key: "aquarius", glyph: "\u2652", name: "Aquarius", element: "air" },
  { key: "pisces", glyph: "\u2653", name: "Pisces", element: "water" },
];

export const PLANET_META = {
  sun: { glyph: "\u2609", label: "Sun", big6: true },
  moon: { glyph: "\u263D", label: "Moon", big6: true },
  rising: { glyph: "\u2191", label: "Rising", big6: true },
  mercury: { glyph: "\u263F", label: "Mercury", big6: true },
  venus: { glyph: "\u2640", label: "Venus", big6: true },
  mars: { glyph: "\u2642", label: "Mars", big6: true },
  jupiter: { glyph: "\u2643", label: "Jupiter", big6: false },
  saturn: { glyph: "\u2644", label: "Saturn", big6: false },
  uranus: { glyph: "\u2645", label: "Uranus", big6: false },
  neptune: { glyph: "\u2646", label: "Neptune", big6: false },
  pluto: { glyph: "\u2647", label: "Pluto", big6: false },
};

export const SIGN_RULERS = {
  aries: "mars", taurus: "venus", gemini: "mercury", cancer: "moon",
  leo: "sun", virgo: "mercury", libra: "venus", scorpio: "pluto",
  sagittarius: "jupiter", capricorn: "saturn", aquarius: "uranus", pisces: "neptune",
};

export const STAR_CHART_SYSTEMS = {
  western: { label: "Western",        region: "Hellenistic \u00B7 Modern", status: "available", accent: "#68B8C8" },
  vedic:   { label: "Vedic",          region: "Jyotish \u00B7 India",      status: "available", accent: "#D4A574" },
  chinese: { label: "Chinese Zodiac", region: "East Asia",                 status: "available", accent: "#C2625A" },
  mayan:   { label: "Mayan",          region: "Mesoamerica",               status: "available", accent: "#6DA88F" },
};

/* ═══════════════════════ CHINESE ZODIAC DATA ═══════════════════════ */

export const CHINESE_ANIMALS = [
  { key: "rat",     name: "Rat",     char: "鼠", order: 1 },
  { key: "ox",      name: "Ox",      char: "牛", order: 2 },
  { key: "tiger",   name: "Tiger",   char: "虎", order: 3 },
  { key: "rabbit",  name: "Rabbit",  char: "兔", order: 4 },
  { key: "dragon",  name: "Dragon",  char: "龍", order: 5 },
  { key: "snake",   name: "Snake",   char: "蛇", order: 6 },
  { key: "horse",   name: "Horse",   char: "馬", order: 7 },
  { key: "goat",    name: "Goat",    char: "羊", order: 8 },
  { key: "monkey",  name: "Monkey",  char: "猴", order: 9 },
  { key: "rooster", name: "Rooster", char: "雞", order: 10 },
  { key: "dog",     name: "Dog",     char: "狗", order: 11 },
  { key: "pig",     name: "Pig",     char: "豬", order: 12 },
];

export const CHINESE_ELEMENTS = [
  { key: "wood",  name: "Wood",  char: "木" },
  { key: "fire",  name: "Fire",  char: "火" },
  { key: "earth", name: "Earth", char: "土" },
  { key: "metal", name: "Metal", char: "金" },
  { key: "water", name: "Water", char: "水" },
];

// Chinese New Year dates by Gregorian year. Used to determine which zodiac year
// applies for people born in January or early February. CNY can fall anywhere
// from Jan 21 to Feb 20.
export const CHINESE_NEW_YEAR = {
  1920: [2, 20], 1921: [2, 8],  1922: [1, 28], 1923: [2, 16], 1924: [2, 5],
  1925: [1, 24], 1926: [2, 13], 1927: [2, 2],  1928: [1, 23], 1929: [2, 10],
  1930: [1, 30], 1931: [2, 17], 1932: [2, 6],  1933: [1, 26], 1934: [2, 14],
  1935: [2, 4],  1936: [1, 24], 1937: [2, 11], 1938: [1, 31], 1939: [2, 19],
  1940: [2, 8],  1941: [1, 27], 1942: [2, 15], 1943: [2, 5],  1944: [1, 25],
  1945: [2, 13], 1946: [2, 2],  1947: [1, 22], 1948: [2, 10], 1949: [1, 29],
  1950: [2, 17], 1951: [2, 6],  1952: [1, 27], 1953: [2, 14], 1954: [2, 3],
  1955: [1, 24], 1956: [2, 12], 1957: [1, 31], 1958: [2, 18], 1959: [2, 8],
  1960: [1, 28], 1961: [2, 15], 1962: [2, 5],  1963: [1, 25], 1964: [2, 13],
  1965: [2, 2],  1966: [1, 21], 1967: [2, 9],  1968: [1, 30], 1969: [2, 17],
  1970: [2, 6],  1971: [1, 27], 1972: [2, 15], 1973: [2, 3],  1974: [1, 23],
  1975: [2, 11], 1976: [1, 31], 1977: [2, 18], 1978: [2, 7],  1979: [1, 28],
  1980: [2, 16], 1981: [2, 5],  1982: [1, 25], 1983: [2, 13], 1984: [2, 2],
  1985: [2, 20], 1986: [2, 9],  1987: [1, 29], 1988: [2, 17], 1989: [2, 6],
  1990: [1, 27], 1991: [2, 15], 1992: [2, 4],  1993: [1, 23], 1994: [2, 10],
  1995: [1, 31], 1996: [2, 19], 1997: [2, 7],  1998: [1, 28], 1999: [2, 16],
  2000: [2, 5],  2001: [1, 24], 2002: [2, 12], 2003: [2, 1],  2004: [1, 22],
  2005: [2, 9],  2006: [1, 29], 2007: [2, 18], 2008: [2, 7],  2009: [1, 26],
  2010: [2, 14], 2011: [2, 3],  2012: [1, 23], 2013: [2, 10], 2014: [1, 31],
  2015: [2, 19], 2016: [2, 8],  2017: [1, 28], 2018: [2, 16], 2019: [2, 5],
  2020: [1, 25], 2021: [2, 12], 2022: [2, 1],  2023: [1, 22], 2024: [2, 10],
  2025: [1, 29], 2026: [2, 17], 2027: [2, 6],  2028: [1, 26], 2029: [2, 13],
  2030: [2, 3],
};

// Inner animal from birth month (Gregorian approximation of solar term boundaries).
export const INNER_ANIMAL_BY_MONTH = {
  1: "ox",      2: "tiger",  3: "rabbit",  4: "dragon",
  5: "snake",   6: "horse",  7: "goat",    8: "monkey",
  9: "rooster", 10: "dog",   11: "pig",    12: "rat",
};

// Secret animal from birth hour in traditional Chinese 2-hour blocks.
export function secretAnimalByHour(hour24) {
  if (hour24 === 23 || hour24 === 0) return "rat";
  if (hour24 >= 1 && hour24 < 3) return "ox";
  if (hour24 >= 3 && hour24 < 5) return "tiger";
  if (hour24 >= 5 && hour24 < 7) return "rabbit";
  if (hour24 >= 7 && hour24 < 9) return "dragon";
  if (hour24 >= 9 && hour24 < 11) return "snake";
  if (hour24 >= 11 && hour24 < 13) return "horse";
  if (hour24 >= 13 && hour24 < 15) return "goat";
  if (hour24 >= 15 && hour24 < 17) return "monkey";
  if (hour24 >= 17 && hour24 < 19) return "rooster";
  if (hour24 >= 19 && hour24 < 21) return "dog";
  if (hour24 >= 21 && hour24 < 23) return "pig";
  return null;
}

/* ═══════════════════════ MAYAN TZOLK'IN DATA ═══════════════════════ */

// The 20 day signs (nawales), in the traditional K'iche' count kept by
// daykeepers (ajq'ijab') in highland Guatemala. Order is canonical and used for
// modular arithmetic; keys are the older Yucatec-style names and must not
// change (saved charts and tags use them). `yucatec` is the name most books
// use. Writeups are in starChartMayanContent.js. No Dreamspell vocabulary.
export const MAYAN_DAY_SIGNS = [
  { key: "imix",     name: "Imox",     yucatec: "Imix",     symbol: "Water / Crocodile", theme: "Water, intuition, the left hand" },
  { key: "ik",       name: "Iq'",      yucatec: "Ik'",      symbol: "Wind",              theme: "Wind, breath, the spirit" },
  { key: "akbal",    name: "Aq'ab'al", yucatec: "Ak'b'al",  symbol: "Dawn",              theme: "Dawn, hope, new starts" },
  { key: "kan",      name: "K'at",     yucatec: "K'an",     symbol: "Net",               theme: "The net, gathering, being caught" },
  { key: "chikchan", name: "Kan",      yucatec: "Chikchan", symbol: "Serpent",           theme: "Power, wisdom, justice" },
  { key: "kimi",     name: "Kame",     yucatec: "Kimi",     symbol: "Death",             theme: "The ancestors, endings, peace" },
  { key: "manik",    name: "Kej",      yucatec: "Manik'",   symbol: "Deer",              theme: "Strength, leadership, balance" },
  { key: "lamat",    name: "Q'anil",   yucatec: "Lamat",    symbol: "Seed",              theme: "Seed, growth, harvest" },
  { key: "muluk",    name: "Toj",      yucatec: "Muluk",    symbol: "Offering",          theme: "Offering, gratitude, what is owed" },
  { key: "ok",       name: "Tz'i'",    yucatec: "Ok",       symbol: "Dog",               theme: "Loyalty, law, justice" },
  { key: "chuwen",   name: "B'atz'",   yucatec: "Chuwen",   symbol: "Thread / Monkey",   theme: "Thread, time, the arts" },
  { key: "eb",       name: "E",        yucatec: "Eb'",      symbol: "Road",              theme: "The road, travel, destiny" },
  { key: "ben",      name: "Aj",       yucatec: "B'en",     symbol: "Cane",              theme: "Home, family, growing tall" },
  { key: "ix",       name: "I'x",      yucatec: "Ix",       symbol: "Jaguar",            theme: "The earth, the night, strength" },
  { key: "men",      name: "Tz'ikin",  yucatec: "Men",      symbol: "Bird",              theme: "Fortune, vision, the messenger" },
  { key: "kib",      name: "Ajmaq",    yucatec: "Kib'",     symbol: "Owl / Vulture",     theme: "Forgiveness, faults, the ancestors" },
  { key: "kaban",    name: "No'j",     yucatec: "Kab'an",   symbol: "Thought",           theme: "Thought, knowledge, counsel" },
  { key: "etznab",   name: "Tijax",    yucatec: "Etz'nab'", symbol: "Flint",             theme: "Cutting, healing, hard truths" },
  { key: "kawak",    name: "Kawoq",    yucatec: "Kawak",    symbol: "Storm",             theme: "Storm, rain, community" },
  { key: "ajpu",     name: "Ajpu",     yucatec: "Ajaw",     symbol: "Hunter / Sun",      theme: "Courage, skill, victory" },
];

// The 13 numbers, with their K'iche' names. Daykeepers read low numbers as
// gentle and high numbers as strong: the number says how forcefully the day
// sign comes through. Where the bands begin and end varies by teacher; the
// middle numbers (around 7-9) are the balanced ones often chosen for ceremony.
// (The Dreamspell names "Magnetic", "Lunar" and so on come from Argüelles,
// around 1990, and are not part of the traditional count.)
// Never look a sign up by name: K'iche' Kan (key chikchan) is not Yucatec
// K'an (key kan, K'iche' K'at).
export const MAYAN_TONES = [
  { number: 1,  name: "Jun",        strength: "gentle" },
  { number: 2,  name: "Keb'",       strength: "gentle" },
  { number: 3,  name: "Oxib'",      strength: "gentle" },
  { number: 4,  name: "Kajib'",     strength: "middle" },
  { number: 5,  name: "Job'",       strength: "middle" },
  { number: 6,  name: "Waqib'",     strength: "middle" },
  { number: 7,  name: "Wuqub'",     strength: "middle" },
  { number: 8,  name: "Wajxaqib'",  strength: "middle" },
  { number: 9,  name: "B'elejeb'",  strength: "middle" },
  { number: 10, name: "Lajuj",      strength: "strong" },
  { number: 11, name: "Junlajuj",   strength: "strong" },
  { number: 12, name: "Kab'lajuj",  strength: "strong" },
  { number: 13, name: "Oxlajuj",    strength: "strong" },
];

/* ═══════════════════════ CUSTOM ASTRO GLYPHS ═══════════════════════ */

export const FALLBACK_GLYPHS = {
  aries: "\u2648", taurus: "\u2649", gemini: "\u264A", cancer: "\u264B", leo: "\u264C", virgo: "\u264D",
  libra: "\u264E", scorpio: "\u264F", sagittarius: "\u2650", capricorn: "\u2651", aquarius: "\u2652", pisces: "\u2653",
  sun: "\u2609", moon: "\u263D", rising: "\u2191", mercury: "\u263F", venus: "\u2640", mars: "\u2642",
  jupiter: "\u2643", saturn: "\u2644", uranus: "\u2645", neptune: "\u2646", pluto: "\u2647", northNode: "\u260A",
};

export const GLYPH_PATHS = {
  // ═══ ZODIAC SIGNS ═══
  aries: [
    { d: "M7 20C7 20 7.5 12 12 6C12.5 5.2 12 4.5 12 4.5", sw: 1.6 },
    { d: "M17 20C17 20 16.5 12 12 6", sw: 1.6 },
    { d: "M12 6C10 9 8 11 7 14", sw: 0.8, op: 0.5 },
    { d: "M12 6C14 9 16 11 17 14", sw: 0.8, op: 0.5 },
    { d: "M12 4.5 Q11 3 9.5 4Q8 5 9 6.5", sw: 1.3 },
    { d: "M12 4.5 Q13 3 14.5 4Q16 5 15 6.5", sw: 1.3 },
    { d: "M11.5 5.5L12.5 5.5", sw: 0.6, op: 0.4 },
    { d: "", sw: 0, fill: true, op: 0 },
  ],
  taurus: [
    { d: "M8 10 A4 4 0 1 1 16 10 A4 4 0 1 1 8 10Z", sw: 1.4 },
    { d: "M8 10Q8 6 6 3Q5.5 2 5 2.5", sw: 1.4 },
    { d: "M16 10Q16 6 18 3Q18.5 2 19 2.5", sw: 1.4 },
    { d: "M6 3Q8 4.5 12 4.5Q16 4.5 18 3", sw: 0.7, op: 0.4 },
    { d: "M12 6L12 6.3", sw: 2, fill: true, op: 0.3 },
  ],
  gemini: [
    { d: "M8 4L16 4", sw: 1.4 },
    { d: "M8 20L16 20", sw: 1.4 },
    { d: "M10 4L10 20", sw: 1.5 },
    { d: "M14 4L14 20", sw: 1.5 },
    { d: "M7 4Q8 3.5 8 4", sw: 0.7, op: 0.5 },
    { d: "M17 4Q16 3.5 16 4", sw: 0.7, op: 0.5 },
    { d: "M7 20Q8 20.5 8 20", sw: 0.7, op: 0.5 },
    { d: "M17 20Q16 20.5 16 20", sw: 0.7, op: 0.5 },
    { d: "M12 11L12 13", sw: 0.6, op: 0.3 },
  ],
  cancer: [
    { d: "M6 10A4 4 0 1 1 14 10", sw: 1.4 },
    { d: "M18 14A4 4 0 1 1 10 14", sw: 1.4 },
    { d: "M14 10Q16 10 18 12Q18.5 13 18 14", sw: 1.2 },
    { d: "M10 14Q8 14 6 12Q5.5 11 6 10", sw: 1.2 },
    { d: "M8 10L8 10.3", sw: 2.5, fill: true, op: 0.4 },
    { d: "M16 14L16 14.3", sw: 2.5, fill: true, op: 0.4 },
  ],
  leo: [
    { d: "M6 14A4 4 0 1 1 14 14A4 4 0 0 0 14 6", sw: 1.4 },
    { d: "M14 6Q14 4 16 3Q18 2 19 4Q20 6 18 8Q16 10 18 14Q19 16 18 18", sw: 1.4 },
    { d: "M18 18Q17 20 19 20.5", sw: 1.2 },
    { d: "M10 14L10 14.3", sw: 2, fill: true, op: 0.3 },
  ],
  virgo: [
    { d: "M5 18L5 6Q5 4 7 4Q9 4 9 6L9 18", sw: 1.4 },
    { d: "M9 6Q9 4 11 4Q13 4 13 6L13 18", sw: 1.4 },
    { d: "M13 6Q13 4 15 4Q17 4 17 6L17 14Q17 16 19 16L20 15", sw: 1.4 },
    { d: "M15 14L19 10", sw: 1.0, op: 0.6 },
    { d: "M17 12L19 14", sw: 0.8, op: 0.4 },
  ],
  libra: [
    { d: "M4 18L20 18", sw: 1.5 },
    { d: "M4 14L20 14", sw: 0.8, op: 0.5 },
    { d: "M12 14Q8 14 7 10Q6 6 12 5Q18 6 17 10Q16 14 12 14Z", sw: 1.4 },
    { d: "M12 5L12 4.5", sw: 0.7, op: 0.4 },
    { d: "M3 18L4 18", sw: 0.8, op: 0.4 },
    { d: "M20 18L21 18", sw: 0.8, op: 0.4 },
  ],
  scorpio: [
    { d: "M4 18L4 8Q4 5 6 5Q8 5 8 8L8 18", sw: 1.4 },
    { d: "M8 8Q8 5 10 5Q12 5 12 8L12 18", sw: 1.4 },
    { d: "M12 8Q12 5 14 5Q16 5 16 8L16 16Q16 18 18 18L20 16", sw: 1.4 },
    { d: "M18.5 17.5L20 16L20 18.5", sw: 1.2 },
  ],
  sagittarius: [
    { d: "M5 19L19 5", sw: 1.6 },
    { d: "M14 5L19 5L19 10", sw: 1.4 },
    { d: "M9 14L15 14", sw: 0.9, op: 0.6 },
    { d: "M12 11L12 17", sw: 0.9, op: 0.6 },
    { d: "M19 5L19.5 4.5", sw: 0.7, op: 0.4 },
  ],
  capricorn: [
    { d: "M5 4L5 16Q5 18 7 18Q9 18 9 16L9 4", sw: 1.4 },
    { d: "M9 12Q12 12 14 14Q16 16 18 16Q20 16 20 14Q20 10 16 10Q14 10 14 12Q14 16 16 20", sw: 1.3 },
    { d: "M16 20Q17 21 18 20.5", sw: 0.8, op: 0.5 },
  ],
  aquarius: [
    { d: "M4 9L7 7L10 9L13 7L16 9L19 7", sw: 1.5 },
    { d: "M4 15L7 13L10 15L13 13L16 15L19 13", sw: 1.5 },
    { d: "M3.5 9L4 9", sw: 0.7, op: 0.4 },
    { d: "M19 7L19.5 7", sw: 0.7, op: 0.4 },
    { d: "M3.5 15L4 15", sw: 0.7, op: 0.4 },
    { d: "M19 13L19.5 13", sw: 0.7, op: 0.4 },
  ],
  pisces: [
    { d: "M8 4Q5 8 5 12Q5 16 8 20", sw: 1.4 },
    { d: "M16 4Q19 8 19 12Q19 16 16 20", sw: 1.4 },
    { d: "M5 12L19 12", sw: 1.2 },
    { d: "M8 4Q7.5 3.5 8 3", sw: 0.7, op: 0.4 },
    { d: "M16 4Q16.5 3.5 16 3", sw: 0.7, op: 0.4 },
    { d: "M8 20Q7.5 20.5 8 21", sw: 0.7, op: 0.4 },
    { d: "M16 20Q16.5 20.5 16 21", sw: 0.7, op: 0.4 },
  ],
  // ═══ PLANETS ═══
  sun: [
    { d: "M12 4.5A7.5 7.5 0 1 1 12 19.5A7.5 7.5 0 1 1 12 4.5Z", sw: 1.4 },
    { d: "M12 11.2A0.8 0.8 0 1 1 12 12.8A0.8 0.8 0 1 1 12 11.2Z", sw: 0.8, fill: true },
    { d: "M12 2.5L12 4", sw: 0.8, op: 0.5 },
    { d: "M12 20L12 21.5", sw: 0.8, op: 0.5 },
    { d: "M2.5 12L4 12", sw: 0.8, op: 0.5 },
    { d: "M20 12L21.5 12", sw: 0.8, op: 0.5 },
    { d: "M5.3 5.3L6.4 6.4", sw: 0.6, op: 0.35 },
    { d: "M17.6 17.6L18.7 18.7", sw: 0.6, op: 0.35 },
    { d: "M5.3 18.7L6.4 17.6", sw: 0.6, op: 0.35 },
    { d: "M17.6 6.4L18.7 5.3", sw: 0.6, op: 0.35 },
  ],
  moon: [
    { d: "M15 4Q9 6 9 12Q9 18 15 20Q11 19 8.5 16Q6 13 6 10Q6 5 10 3Q12 2 15 4Z", sw: 1.4 },
    { d: "M16 5L16.8 4L17 5.2", sw: 0.8, op: 0.5 },
    { d: "M17.5 7L18.3 6L18.5 7.2", sw: 0.6, op: 0.35 },
  ],
  rising: [
    { d: "M4 16L20 16", sw: 1.4 },
    { d: "M12 16L12 4", sw: 1.5 },
    { d: "M8 8L12 4L16 8", sw: 1.3 },
    { d: "M4 16Q3.5 16.5 4 17", sw: 0.7, op: 0.4 },
    { d: "M20 16Q20.5 16.5 20 17", sw: 0.7, op: 0.4 },
    { d: "M12 4L12 3.5", sw: 0.7, op: 0.4 },
  ],
  mercury: [
    { d: "M8.5 11A3.5 3.5 0 1 1 15.5 11A3.5 3.5 0 1 1 8.5 11Z", sw: 1.3 },
    { d: "M12 14.5L12 20", sw: 1.4 },
    { d: "M9 18L15 18", sw: 1.0 },
    { d: "M9 5Q12 2 15 5", sw: 1.3 },
    { d: "M9 5Q9 7.5 12 7.5Q15 7.5 15 5", sw: 1.0, op: 0.6 },
    { d: "M12 20L12 20.5", sw: 0.7, op: 0.4 },
  ],
  venus: [
    { d: "M8.5 9A3.5 3.5 0 1 1 15.5 9A3.5 3.5 0 1 1 8.5 9Z", sw: 1.4 },
    { d: "M12 12.5L12 20", sw: 1.4 },
    { d: "M9 17L15 17", sw: 1.0 },
    { d: "M12 20L12 20.5", sw: 0.7, op: 0.4 },
  ],
  mars: [
    { d: "M7 15A5 5 0 1 1 17 15A5 5 0 1 1 7 15Z", sw: 1.4 },
    { d: "M15 9L20 4", sw: 1.4 },
    { d: "M16 4L20 4L20 8", sw: 1.3 },
    { d: "M20 4L20.5 3.5", sw: 0.7, op: 0.4 },
  ],
  jupiter: [
    { d: "M4 10L14 10", sw: 1.4 },
    { d: "M14 4Q18 4 18 8Q18 12 14 12L14 4", sw: 1.3 },
    { d: "M14 12L14 20", sw: 1.4 },
    { d: "M4 10L3.5 10", sw: 0.7, op: 0.4 },
    { d: "M14 20L14 20.5", sw: 0.7, op: 0.4 },
  ],
  saturn: [
    { d: "M10 4L10 20", sw: 1.4 },
    { d: "M7 4L13 4", sw: 1.2 },
    { d: "M10 12Q6 12 6 16Q6 20 10 20Q14 20 14 16", sw: 1.3 },
    { d: "M7 4L6.5 3.5", sw: 0.7, op: 0.4 },
    { d: "M13 4L13.5 3.5", sw: 0.7, op: 0.4 },
  ],
  uranus: [
    { d: "M9.5 14A2.5 2.5 0 1 1 14.5 14A2.5 2.5 0 1 1 9.5 14Z", sw: 1.3 },
    { d: "M12 11.5L12 4", sw: 1.4 },
    { d: "M12 4L8 4", sw: 1.1 },
    { d: "M12 4L16 4", sw: 1.1 },
    { d: "M8 4L8 7", sw: 1.0 },
    { d: "M16 4L16 7", sw: 1.0 },
    { d: "M12 14L12 14.3", sw: 2, fill: true, op: 0.4 },
  ],
  neptune: [
    { d: "M12 8L12 21", sw: 1.4 },
    { d: "M8 18L16 18", sw: 1.0 },
    { d: "M5 8Q8 3 12 3Q16 3 19 8", sw: 1.4 },
    { d: "M5 8L5 12", sw: 1.1 },
    { d: "M19 8L19 12", sw: 1.1 },
    { d: "M12 3L12 2.5", sw: 0.7, op: 0.4 },
  ],
  pluto: [
    { d: "M12 14L12 21", sw: 1.4 },
    { d: "M8 18L16 18", sw: 1.0 },
    { d: "M8.5 8A3.5 3.5 0 1 1 15.5 8A3.5 3.5 0 1 1 8.5 8Z", sw: 1.3 },
    { d: "M7 4Q12 1 17 4", sw: 1.3 },
    { d: "M7 4Q7 5.5 8.5 5.5", sw: 0.8, op: 0.5 },
    { d: "M17 4Q17 5.5 15.5 5.5", sw: 0.8, op: 0.5 },
  ],
  northNode: [
    { d: "M6 4L6 16Q6 20 12 20Q18 20 18 16L18 4", sw: 1.4 },
    { d: "M5 4A1.5 1.5 0 1 1 8 4A1.5 1.5 0 1 1 5 4Z", sw: 1.0, fill: true, op: 0.5 },
    { d: "M16 4A1.5 1.5 0 1 1 19 4A1.5 1.5 0 1 1 16 4Z", sw: 1.0, fill: true, op: 0.5 },
  ],
};
